module.exports = __webpack_public_path__ + "img/256x256_circle_partial_warp_gate.d35903e6.svg";